/**
 * NCA product deep links for gallery designs — mirrors whatsapp-bridge/ncaProductLink.js
 */
import { NCA_PUBLIC_BASE } from "./galleryConstants";

const CATEGORY_LANE_MAP = {
  BENTO: [["myself", "BENTO"]],
  "DRY CAKE": [["myself", "DRY CAKE"]],
  "CHEESE CAKES": [["myself", "CHEESE CAKE"]],
  ANNIVERSARY: [["anniversary", "ANNIVERSARY"]],
  FESTIVAL: [["occasion", "FESTIVAL"]],
  WEDDING: [["occasion", "WEDDING"]],
  CORPORATE: [["occasion", "CORPORATE"]],
  "BABY SHOWER": [["occasion", "BABY SHOWER"]],
  "BRIDE TO BE": [["occasion", "BRIDE TO BE"]],
  CUPCAKES: [["occasion", "CUPCAKES"]],
  SENIORS: [["occasion", "SENIORS"]],
  PASTRY: [["occasion", "PASTRY"]],
};

const HIM_KEYWORDS = [
  ["DAD", /\bdad\b|\bfather\b|\bpapa\b/i],
  ["HUSBAND", /\bhusband\b|\bhubby\b/i],
  ["BROTHER", /\bbrother\b|\bbhai\b/i],
  ["FRIEND", /\bfriend\b|\bbuddy\b/i],
];

const HER_KEYWORDS = [
  ["WIFE", /\bwife\b|\bwifey\b/i],
  ["MOTHER", /\bmother\b|\bmom\b|\bmummy\b/i],
  ["SISTER", /\bsister\b|\bdidi\b/i],
  ["GIRLFRIEND", /\bgirlfriend\b|\bgf\b/i],
  ["GRANDMA", /\bgrandma\b|\bgrandmother\b|\bnani\b/i],
];

function slug(s) {
  return (
    String(s || "")
      .trim()
      .toLowerCase()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "") || "design"
  );
}

function splitPipe(val) {
  return String(val || "")
    .split("|")
    .map((p) => p.trim())
    .filter(Boolean);
}

function blob(row) {
  return [
    row.display_name,
    row.who_for,
    row.theme,
    row.character_name,
    row.customer_callouts,
    row.text_on_cake,
    row.categorization_notes,
    row.all_categories,
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();
}

function matchKeywords(text, keywords) {
  for (const [spec, pat] of keywords) {
    if (pat.test(text)) return spec;
  }
  return null;
}

function genderLanes(row, vibe, boySpec, girlSpec) {
  const who = new Set(splitPipe(row.who_for).map((w) => w.toLowerCase()));
  const hasBoy = [...who].some((w) => w === "boys" || w === "boy");
  const hasGirl = [...who].some((w) => w === "girls" || w === "girl");
  if (hasBoy && !hasGirl) return [[vibe, boySpec]];
  if (hasGirl && !hasBoy) return [[vibe, girlSpec]];
  return [
    [vibe, boySpec],
    [vibe, girlSpec],
  ];
}

function lanesForCategory(cat, row) {
  const c = String(cat || "")
    .trim()
    .toUpperCase();
  if (CATEGORY_LANE_MAP[c]) return CATEGORY_LANE_MAP[c];
  if (c === "KIDS") return genderLanes(row, "kids", "BOY", "GIRL");
  if (c === "BABIES") return genderLanes(row, "babies", "BOY", "GIRL");
  if (c === "FOR HIM") {
    const spec = matchKeywords(blob(row), HIM_KEYWORDS);
    if (spec) return [["him", spec]];
    return [
      ["him", "DAD"],
      ["him", "HUSBAND"],
      ["him", "BROTHER"],
      ["him", "FRIEND"],
    ];
  }
  if (c === "FOR HER") {
    const spec = matchKeywords(blob(row), HER_KEYWORDS);
    if (spec) return [["her", spec]];
    return [
      ["her", "WIFE"],
      ["her", "MOTHER"],
      ["her", "SISTER"],
      ["her", "GIRLFRIEND"],
      ["her", "GRANDMA"],
    ];
  }
  return [];
}

export function buildNcaProductId(photoId, row) {
  const categories = splitPipe(row.all_categories || row.primary_category || "");
  const laneSet = new Set();
  for (const cat of categories) {
    for (const [vibe, specific] of lanesForCategory(cat, row)) {
      laneSet.add(`${vibe}\0${specific}`);
    }
  }
  if (!laneSet.size) return null;
  const [first] = [...laneSet];
  const [vibe, specific] = first.split("\0");
  const laneSlug = slug(`${vibe}-${specific}`);
  return `gl_${photoId}_${laneSlug}`.slice(0, 64);
}

export function buildNcaProductUrl(photoId, row) {
  const pid = buildNcaProductId(photoId, row);
  if (!pid) return null;
  return `${NCA_PUBLIC_BASE}/product/${encodeURIComponent(pid)}`;
}
